/**
 * Created by aahmed on 05/03/21.
 *
 * AngularJS directive for Zoom Recording Form
 */

'use strict';

angular.module('mediacloudApp')
    .directive('zoomRecording', ['$window', '$filter', '$log', '$timeout', 'Tenant', 'CollectionService', 'SchedulerService', 'Principal', 'atmosphereService', '$http', function($window, $filter, $log, $timeout, Tenant, CollectionService, SchedulerService, Principal, atmosphereService, $http){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/zoom-recording/zoom-recording.html',
            scope: {
                parent: '=',
                toggleZoomRecordingForm: '&',
                activeLink: '=',
                contributors: '=',
                hasEvents: '=',
                reset: '&',
                allowScheduling: '=',
                account: '='
            },
            link: function(scope, element, attr) {

                scope.zoomUserRecordingInProgress = false;

                scope.event = {
                    metadata: {
                        title: '',
                        type: '',
                        description: '',
                        destination: scope.parent
                    },
                };

                var atmosphereSetup = function () {
                    if(!scope.account) {
                        return;
                    }

                    var request = {
                        url: scope.notificationUrl + 'zoom/recording/' + scope.account.login,
                        contentType: 'application/json',
                        logLevel: 'debug',
                        transport: 'websocket',
                        fallbackTransport: 'streaming',
                        trackMessageLength: true,
                        reconnectInterval: 5000,
                        enableXDR: true,
                        timeout: 300000,
                        shared: true
                    };

                    request.onOpen = function(response) {
                        console.log('Atmosphere connected using ' + response.transport);
                    };

                    request.onMessage = function (response) {
                        try{
                            var message = JSON.parse(response.responseBody);
                            if (message.messageType === 'recording') {
                                scope.zoomUserRecordingInProgress = false;
                            }
                        }catch(err) {
                            console.log(err.message);
                        }
                    };

                    request.onClientTimeout = function (response) {
                        setTimeout(function () {
                            atmosphereService.subscribe(request);
                        }, request.reconnectInterval);
                    };
                    atmosphereService.subscribe(request);
                };


                scope.checkForRecording = function () {
                    SchedulerService.UserRecordingInProgress.get({}, function(response){
                        scope.zoomUserRecordingInProgress = response.zoomUserRecordingInProgress;
                        console.log('user recording in progress: ', scope.zoomUserRecordingInProgress);
                        if (scope.zoomUserRecordingInProgress) {
                            $('#startRecordingBtn').addClass('inactiveBtn');
                        }
                    });
                };

                var loadForm = function() {
                    $http({
                        method: 'GET',
                        url: 'api/properties?name=NOTIFICATION_URL'
                    }).then(function successCallback(response) {
                        scope.notificationUrl = response.data.value;
                        console.log("notification URL: ", scope.notificationUrl);
                        atmosphereSetup();
                    });
                    scope.checkForRecording();
                    SchedulerService.getContributors({baseCollectionId: scope.parent.cid})
                    .then(function(response){
                        scope.contributor = response.find(x => x.user.login === scope.account.login);
                        console.log('contributor: ', scope.contributor);
                    }).catch(function(err) {
                        scope.error = err;
                        $log.error("An error occurred when trying to fetch contributors");
                    });
                    scope.dateTimePicker = SchedulerService.getDateTimePicker();
                };

                scope.$watch('activeLink', function(){
                    if(scope.activeLink){
                        if(scope.activeLink === 'zoomrecording'){
                            loadForm();
                        }
                    }
                });

                // Tenant Info
                Tenant.info().then(function (data) {
                    if(data) {
                        scope.tenantId = data.id;
                        scope.showUserFullName = data.showUserFullName;
                    }

                });

                // username code
                var userInfo = Principal.getUserInfo();
                scope.userName = userInfo.userName;
                scope.userFullName = userInfo.userFullName;

                SchedulerService.checkAvailability.get({baseCollectionId: scope.parent.cid}, function(response){
                    scope.allowScheduling = response.result;
                    if(scope.allowScheduling) {
                        $('#zoomRecButton').hide();
                    }
                    else {
                        $('#startRecordingBtn').addClass('inactiveBtn');
                        $('#zoomRecButton').show();
                    }
                });

                scope.save = function(){
                    if(scope.event.metadata.title && scope.event.metadata.type){
                        var startRecordingRequest = {
                            title: scope.event.metadata.title,
                            type: scope.event.metadata.type,
                            contributor: scope.contributor.userId,
                            description: scope.event.metadata.description.trim(),
                            startTime: moment(new Date().clearSeconds()).format("YYYY-MM-DD HH:mm:ss"),
                            timeZone: scope.dateTimePicker.timeZones[0].key
                        };
                        var addEventResource = SchedulerService.addEvent({
                            baseCollectionId: scope.parent.cid,
                            destinationCollectionId: scope.event.metadata.destination.cid,
                            meetingType: 1,
                            recordingOption: scope.event.metadata.type
                        });
                        $("div.spanner").addClass("show");
                        $("div.overlay").addClass("show");
                        addEventResource.save(startRecordingRequest, function (response) {
                            $("div.spanner").removeClass("show");
                            $("div.overlay").removeClass("show");
                            if (response.startUrl != null && response.startUrl != '') {
                                scope.event.metadata.title = '';
                                scope.event.metadata.type = '';
                                scope.event.metadata.description = '';
                                scope.zoomUserRecordingInProgress = true;
                                $window.open(response.startUrl, "_blank");
                            }
                            else {
                                alert('An error occurred when trying to launch the meeting. Please try again.')
                            }
                            scope.reset();
                        });
                    }
                };

                scope.changeDestination = function(destination){
                    scope.event.metadata.destination = destination;
                };

                scope.launchZoom = function () {
                    SchedulerService.OAuth.get({standaloneInstall: false}, function(response){
                        var win = window.open(response.requestUrl, 'Authentication', 'width=972,height=660,modal=yes,alwaysRaised=yes');
                    });
                };
            }
        }
    }]);
